// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"99":"19a87262","160":"a4b38007","395":"a21a45d6","453":"b1679f88","500":"8b7c5c46","515":"1d0364e5","545":"85652f59","658":"e6d7160d","672":"a642fceb","723":"a9510620","795":"62bee776","800":"9b25f402","863":"0471245d","930":"a935181c"}[chunkId] + ".chunk.js";
};